import { useQuery } from '@tanstack/react-query';

import { getCase } from '~/services/ContractingService';

import { retryUnlessRejected } from './retryUnlessRejected';

export const caseQueryKeys = {
  all: ['contracting', 'cases'] as const,
  detail: (caseNumber: string) => [...caseQueryKeys.all, 'detail', caseNumber] as const,
};

export function useGetCase(caseNumber: string | undefined) {
  return useQuery({
    queryKey: caseQueryKeys.detail(caseNumber ?? ''),
    queryFn: ({ signal }) => getCase(caseNumber ?? '', { signal }),
    enabled: !!caseNumber,
    retry: retryUnlessRejected,
  });
}
